export default function isNumeric(value: number | undefined) {
  if (typeof value !== 'number') {
    return false;
  } else if (isNaN(value)) {
    return false;
  }

  return true;
}
